import { useDrop } from 'react-dnd';
import { ROW_ITEM_DRAG_TYPE } from '../dataTable/components/Row';
export var useReferenceFieldDrop = function (_a) {
    var testDraggedItem = _a.testDraggedItem, testDroppedItem = _a.testDroppedItem, onValidDrop = _a.onValidDrop, disabled = _a.disabled;
    return useDrop({
        accept: ROW_ITEM_DRAG_TYPE,
        drop: function (item, monitor) {
            if (testDroppedItem && onValidDrop) {
                testDroppedItem(item.rowItem)
                    .then(function (validRowItem) { return onValidDrop(validRowItem); })
                    .catch(function () { return console.log('Invalid item dropped on field ', item.rowItem); });
            }
        },
        collect: function (monitor) {
            var _a;
            return ({
                hovered: monitor.isOver(),
                validDropTarget: !disabled && testDraggedItem && testDraggedItem((_a = monitor.getItem()) === null || _a === void 0 ? void 0 : _a.rowItem),
            });
        }
    });
};
//# sourceMappingURL=dragAndDropHook.js.map